import { Link } from 'react-router-dom';

const ScrollLink = ({ to, children, ...props }) => (
  <Link
    to={to}
    {...props}
    onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
  >
    {children}
  </Link>
);

export default ScrollLink;